import {
  DELETE_PRE_REGISTERED_DOCUMENTS_REQUEST,
  GET_PRE_REGISTERED_DOCUMENTS_REQUEST,
} from './types';

const getPreRegisteredDocuments = (payload) => ({
  type: GET_PRE_REGISTERED_DOCUMENTS_REQUEST,
  payload,
});

const deletePreRegisterDocuments = (payload) => ({
  type: DELETE_PRE_REGISTERED_DOCUMENTS_REQUEST,
  payload,
});

export { deletePreRegisterDocuments, getPreRegisteredDocuments };
